import { useParams } from 'react-router-dom';

import { useHeader } from 'context';
import { Customers } from 'components';
import { useAppSelector } from 'store';
import { BackOfficeRoles } from 'types';
import { selectAuthUser } from 'store/slices/auth';

export const Edit = () => {
  const { id } = useParams();
  const authUser = useAppSelector(selectAuthUser);

  // Owner 25 Oct 2026: a Sales Rep never sees the company's employee list;
  // the Employee field offers only the rep (as the POS customer form does).
  const isSalesRep = authUser?.role?.name === BackOfficeRoles.SALES_REP;

  useHeader({
    showBackButton: true,
    pageName: 'Edit customer',
  });

  return (
    <Customers.Edit
      id={id}
      employeeOptions={
        isSalesRep
          ? [
              {
                label: authUser?.name || '',
                value: authUser?.id ? String(authUser.id) : '',
              },
            ]
          : undefined
      }
    />
  );
};
